import { CreditCard } from 'lucide-react'
import { Button } from '@/components/ui/button'

const PRICING_URL = 'https://pharmatext.ai/#pricing'

/**
 * Pay-first dead-end: shown by `SubscriptionGate` in App.tsx when the backend
 * answers 402 for an authenticated user with no org/subscription (the
 * `ALLOW_UNPAID_SIGNUP_ORG` gate, off in prod). A polite wall instead of the
 * legacy NULL-org fallback mode — the user has a valid WorkOS login but
 * nothing provisioned, so the only ways forward are subscribing (the Stripe
 * webhook then creates their org) or accepting a pending team invitation.
 */
export function SubscribeGate({ onSignOut }: { onSignOut: () => void }) {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-muted/30 px-4">
      <div className="w-full max-w-md rounded-2xl border border-border bg-background p-8 text-center shadow-sm">
        <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-full bg-pharma-primary/10">
          <CreditCard className="h-7 w-7 text-pharma-primary" />
        </div>

        <h1 className="text-xl font-semibold text-foreground">
          No active subscription
        </h1>

        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
          You&rsquo;re signed in, but this account doesn&rsquo;t have a PharmaText
          subscription yet. Subscribe to set up your workspace and start
          verifying documents.
        </p>

        <div className="mt-6 rounded-lg border border-border bg-muted/40 p-4 text-left text-xs leading-relaxed text-muted-foreground">
          <p>
            Invited to join a team? Open the invitation email and accept it
            there, then sign in again.
          </p>
        </div>

        <div className="mt-6 flex flex-col items-center gap-3">
          <Button
            asChild
            className="bg-pharma-primary hover:bg-pharma-primary/90 text-white"
          >
            <a href={PRICING_URL}>View plans &amp; subscribe</a>
          </Button>
          <button
            onClick={onSignOut}
            className="text-sm font-medium text-muted-foreground hover:text-foreground hover:underline"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  )
}
